const Menu = [
  //   { header: "Apps" },
  {
    title: "Dashboard",
    group: "apps",
    icon: "dashboard",
    name: "dashboard"
  },
  { divider: true },
  {
    title: "Agents Info",
    group: "",
    icon: "fa fa-home",
    items: [
      {
        component: "main/users",
        icon: "fa fa-user",
        title: "Agents Account"
      },
      {
        component: "user/kyc",
        icon: "fa fa-user",
        title: "Agent Kyc Requests"
      },
      {
        component: "user/kyc-verified",
        icon: "fa fa-user",
        title: "Agent Kyc Verified"
      },
      {
        component: "user/kyc-rejected",
        icon: "fa fa-user",
        title: "Agent Kyc Rejected"
      }
    ]
  },
  {
    icon: "fa fa-tasks",
    title: "Reports",
    group: "report",
    items: [
      {
        name: "queue",
        icon: "fa fa-tasks",
        title: "Queue"
      },
      {
        name: "technical",
        icon: "fa fa-tasks",
        title: "Technical"
      },
      {
        name: "financial",
        icon: "fa fa-money",
        title: "Financial"
      },
      {
        name: "airtime",
        icon: "fa fa-university",
        title: "Airtime"
      },
      {
        name: "monnify",
        icon: "widgets",
        title: "Monnify"
      }
    ]
  },
  {
    icon: "fa fa-university",
    group: "cashin",
    title: "Cash",
    items: [
      {
        name: "bank",
        icon: "fa fa-university",
        title: "Bank"
      },
      {
        name: "cashin",
        icon: "fa fa-money",
        title: "Cash In"
      },
      {
        name: "online-bank-reconcilate",
        icon: "fa fa-exclamation-circle",
        title: "Online Bank"
      }
    ]
  },
  {
    icon: "fa fa-wrench",
    title: "Admin Tools",
    group: "admin_tools",
    items: [
      // {
      //   name: "edit_menu",
      //   icon: "fa fa-edit",
      //   title: "Edit Menu"
      // },
      {
        name: "get_sms_code",
        icon: "fa fa-wrench",
        title: "SMS Code"
      },
      // {
      //   name: "change_roles",
      //   icon: "fa fa-edit",
      //   title: "Change Role"
      // },
      // {
      //   name: "edit_permissions",
      //   icon: "fa fa-edit",
      //   title: "Edit permissions"
      // },
      {
        name: "password_change",
        icon: "fa fa-edit",
        title: "Change password"
      },
      { name: "staff", icon: "fa fa-users", title: "Staff" },
      { name: "permissions", icon: "fa fa-key", title: "Permissions" }
    ]
  },
  {
    icon: "fa fa-wrench",
    title: "Provider",
    group: "provider",
    items: [
      {
        name: "list",
        icon: "fa fa-money",
        title: "Providers"
      },
      {
        name: "balances",
        icon: "fa fa-money",
        title: "Providers Balances"
      },
      {
        name: "commissions",
        icon: "fa fa-money",
        title: "Commissions"
      }
    ]
  },
  {
    icon: "fa fa-line-chart",
    title: "Charts",
    group: "chart",
    items: [
      {
        name: "agent_transactions_and_tua_profit_dynamics",
        icon: "fa fa-line-chart",
        title: "Agent transactions and TUA profit dynamics"
      },
      {
        name: "sales_and_profit_by_providers",
        icon: "fa fa-line-chart",
        title: "Sales and profit by providers"
      },
      {
        name: "sales_and_profit_dynamics_by_providers",
        icon: "fa fa-line-chart",
        title: "Sales and profit dynamics by providers"
      },
      {
        name: "sales_and_agents_deposites_dynamic",
        icon: "fa fa-line-chart",
        title: "Sales and agents deposites dynamic"
      },
      {
        name: "agents_deposits_and_profit_balance",
        icon: "fa fa-line-chart",
        title: "Agents deposits and profit balance"
      },
      {
        name: "number_of_tua_accounts",
        icon: "fa fa-line-chart",
        title: "Number of TUA accounts"
      },
      {
        name: "sales_by_airtime_credit",
        icon: "fa fa-line-chart",
        title: "Airtime credited by Banks/Cash"
      },
      {
        name: "agents_sales",
        icon: "fa fa-line-chart",
        title: "Agents sales"
      },
      {
        name: "monthly_total_sales",
        icon: "fa fa-line-chart",
        title: "Monthly total sales"
      },
      {
        name: "monthly_average",
        icon: "fa fa-line-chart",
        title: "Monthly Average"
      },
      {
        name: "users_and_referals",
        icon: "fa fa-line-chart",
        title: "Users And Referals"
      },
      {
        name: "general",
        icon: "fa fa-line-chart",
        title: "General Report"
      }
    ]
  }
  // {
  //   icon: "fa fa-users",
  //   title: "Agents Network",
  //   group: "vendors",
  //   items: [
  //     {
  //       name: "new-vendor",
  //       icon: "fa fa-user",
  //       title: "Fill Form",
  //     },
  //     {
  //       name: "vendors",
  //       icon: "fa fa-user",
  //       title: "Vendors",
  //     }
  //   ]
  // }
];
// reorder menu
// Menu.forEach(item => {
//   if (item.items) {
//   }
// });

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js